module.exports = __webpack_public_path__ + "img/8.6322f82.png";